import React from 'react';
import { DashboardStatCard } from 'app/shared/cards/stat/dashboard-stat';
import { toReadableNumber } from 'app/shared/utils/number';
import styles from './metrics.module.css';

export const MetricsBar = ({
  track,
  loading = false,
  client_count = 0,
  total_earnings = 0,
  pending_earnings = 0,
  total_spend = 0,
  currency_symbol = '₦'
}) => {
  const money = (amount) => `${currency_symbol}${toReadableNumber(amount)}`;

  const clients_card = (
    <DashboardStatCard
      key="clients"
      label="Clients"
      value={loading ? null : (client_count || 0).toLocaleString()}
      loading={loading}
    />
  );

  // Freelancers earn margin on their clients; businesses spend on subscriptions.
  // Show only the metrics that make sense for the partner's track.
  const cards =
    track === 'business'
      ? [
          clients_card,
          <DashboardStatCard
            key="total_spend"
            label="Total spend"
            value={loading ? null : money(total_spend)}
            loading={loading}
          />
        ]
      : [
          clients_card,
          <DashboardStatCard
            key="total_earnings"
            label="Total earnings"
            value={loading ? null : money(total_earnings)}
            loading={loading}
          />,
          <DashboardStatCard
            key="pending_earnings"
            label="Pending earnings"
            value={loading ? null : money(pending_earnings)}
            context={!loading && pending_earnings === 0 ? 'Nothing pending' : undefined}
            loading={loading}
          />
        ];

  return <div className={styles.grid}>{cards}</div>;
};
